import React, { Fragment, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { Tag, Input, Radio, Spin, Button, Drawer } from 'antd';
import { Form } from 'antd';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { tableTranslation } from '../../../Utils/Adapter/translationAdapter';
import { config } from '../../constant';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import StyledTable from '../../../../../commons/styles/table';

const FeedbackTable = (props) => {


  const [columns, setColumns] = useState([]);
  const [tabledata, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const refreshDateTime = useState(moment());
  const [searchText, setSearchText] = useState('');
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  var searchInput = '';
  
  let feedbackRef = React.createRef();
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const openModalVisible = (e, record) => {
    setOpenModal(!openModal);
    setModalObj(record);
  };

  const getActionColumn = (text) => {
    return (
      <div onClick={(e) => openModalVisible(e, text)} style={{ color: '#fff' }}>
        Click to feedback
      </div>
    );
  };

  const getColumnSearchProps = (dataIndex) => {
    const filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    );
    const filterIcon = (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    );
    const onFilter = (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    const onFilterDropdownOpenChange = (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    };
    const render = (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: 'white', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    );
    return {
      filterDropdown,
      filterIcon,
      onFilter: (value, record) => onFilter(value, record, dataIndex),
      onFilterDropdownOpenChange,
      render,
    };

  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const updateData = async (data) => {
    let theme = props.selectedThemeing;
    try {
      let columns = [];
      let tabledata = [];
      const columnNames = Object.keys(data[0]);

      columnNames.map((value) => {
        if (
          value.length > 0 &&
          value !== 'color' &&
          value !== 'noData' &&
          value !== 'Action' &&
          value !== 'Comment' &&
          value !== 'Timestamp'
        ) {
          //ignoring columns
          columns.push({
            title: value,
            dataIndex: value,
            key: value,
            ...getColumnSearchProps(value),
            render(text, record) {
              return {
                props: {
                  style: { color: record && record.color ? record.color : '#000' }
                },
                children: (
                  <text style={{ color: record && record.color ? record.color : '#8c8c8c' }}>
                    {text}
                  </text>
                )
              };
            }
          });
        } else if (value && value === 'Action') {
          columns.push({
            title: value,
            dataIndex: value,
            key: value,
            render: (text, row) => {
              return {
                children: getActionColumn(row)
              };
            }
          });
        } else if (value && value === 'Timestamp') {
          columns.push({
            title: value,
            dataIndex: value,
            key: value,
            render: (text, record) => {
              return {
                style: { color: theme === 'lightTheme' ? 'black' : 'white' },
                children: (
                  <text style={{ color: record && record.color ? record.color : '#8c8c8c' }}>
                    {moment(text).format('YYYY-MM-DD HH:mm:ss')}
                  </text>
                )
              };
            }
          });
        }
        return {};
      });

      if (data && data[0] && data[0]['noData']) {
        return {};
      } else {
        data.map((dataval, dataindex) => {
          dataval.key = dataindex + 1;
          tabledata.push(dataval);
          return {};
        });
      }
      let translationTable = await tableTranslation(columns, props.translationCache);
      setColumns(translationTable);
      setTableData(tabledata);
    } catch (e) {
      setColumns([]);
    }
  };

  const getData = async () => {
    requestCheck.current = false;
    setErrorInAPI(false);
    setNoDataInDB(false);
    let json = [];
    let { graphprops } = props;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    requestCheck.current = true;
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      setLoading(false);
      setErrorInAPI(errorInAPI);
      setNoDataInDB(noDataInDB);
    }
    updateData(json);

  };

  const handleOk = () => {
    feedbackRef.current.validateFields().then(async () => {
      //Feedback
      // let response = await this.submitFeedbackAPI(values)
      getData(props);
      setOpenModal(false);
    });
  };

  //  const submitFeedbackAPI = (payload) => {
  //     //API
  //     const accessToken = localStorage.get('accessToken');
  //     const deviceTypeObject = {
  //       method: 'POST',
  //       url: `/predictions/update`,
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`
  //       },
  //       data: payload
  //     };
  //     return axios(deviceTypeObject)
  //       .then(() => {
  //         return 'success';
  //       })
  //       .catch(function () {
  //         return 'error';
  //       });
  //   };

  const handleCancel = () => {
    setOpenModal(false);
  };

  let theme = props.selectedThemeing;
  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          <Drawer
            open={openModal}
            title="Prediction feedback"
            onOk={handleOk}
            onCancel={handleCancel}
            closable
            footer={[
              <Button key="back" onClick={handleCancel}>
                Cancel
              </Button>,
              <Button key="submit" type="primary" onClick={handleOk}>
                Submit
              </Button>
            ]}
          >
            <Form ref={feedbackRef} name="user_form" initialValues={modalObj || {}}>
              <Form.Item
                label=" Is this prediction useful?"
                name="Action"
                rules={[
                  {
                    required: true,
                    message: 'Yes/No ? '
                  }
                ]}
              >
                <Radio.Group>
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label="Comment"
                name="Comment"
                rules={[
                  {
                    required: true,
                    message: 'Please input Comment'
                  }
                ]}
              >
                <Input.TextArea min={'5'} />
              </Form.Item>
            </Form>
          </Drawer>

          {loading === false && columns && columns.length > 0 ? (
            <StyledTable size="small"
              bordered
              scroll={{ x: tabledata.length > 5 ? true : false }}
              className="TableWidget"
              style={{ padding: '0px 10px', marginTop: '12px' }}
              columns={columns}
              dataSource={tabledata}
              pagination={{ pageSize: '5' }}
            />
          ) : (
            <div
              style={{
                textAlign: 'center',
                color: theme === 'lightTheme' ? 'black' : 'white',
                marginTop: '10%'
              }}
            >
              <h2 style={{ color: theme === 'lightTheme' ? 'black' : 'white' }}>
                <Spin spinning={loading} tip="Loading..." ></Spin>
              </h2>
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};



const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.translationCache
  };
};


export default connect(mapStateToProps)(FeedbackTable);
